import React from 'react'
import { Image } from '../image/image'
export class TransferNewsContainer extends React.Component {
  render() {
    return this.props.news.length > 0
      ? <div className="transfer-news--container">
          <div className="section-title transfer-news--title">
            {this.props.title}
          </div>
          <ul>
            {this.props.news.map((item, i) => TransferNewsItem(item, i))}
          </ul>
        </div>
      : null
  }
}

const TransferNewsItem = (props, position) =>
  <a
    className="transfer-news--item"
    href={props.path}
    data-analytics-event-category="Article page"
    data-analytics-event-action="article click"
    data-analytics-event-label="transfer news"
    data-analytics-event-value={`position ${position}`}
    key={position}
  >
    <Image
      lazyLoad={true}
      className="transfer-news--item--image"
      src={props.image}
      alt={props.title}
    />
    <span className="transfer-news--item--title">
      {props.title}
    </span>
  </a>



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/transfer_news/transferNews.container.js